import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseComponent } from '../../../shared';


/**
* Component of table of the generic instrument tray information.
*/
@Component({
	selector: 'plat-instrument-gen-table',
	templateUrl: './plat-instrument-gen-table.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PlatInstrumentGenTableComponent extends BaseComponent {

	@Input() isJPSExtension: boolean = false;

}
